var _path, _path2, _path3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06666 13H18.9333L19.6981 18.7357C19.8579 19.9346 18.9252 21 17.7156 21H6.28436C5.07478 21 4.14204 19.9346 4.30191 18.7357L5.06666 13Z",
    fill: "#6C65F7",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45428 4.91127C5.50125 4.1187 6.15769 3.5 6.95166 3.5H17.0483C17.8423 3.5 18.4987 4.11869 18.5457 4.91127L19.3753 18.9113C19.4264 19.7731 18.7413 20.5 17.878 20.5H6.12203C5.25871 20.5 4.57358 19.7731 4.62465 18.9113L5.45428 4.91127Z",
    stroke: "#6C65F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.96137V8.96137C14 10.0659 13.1046 10.9614 12 10.9614C10.8954 10.9614 10 10.0659 10 8.96137V7.96137",
    stroke: "#6C65F7",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 7,
    width: 1,
    height: 2,
    rx: 0.2,
    fill: "#6C65F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 7,
    width: 1,
    height: 2,
    rx: 0.2,
    fill: "#6C65F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemActive);
export default __webpack_public_path__ + "static/media/item-active.c18e1ad7e37364390a2f50f793a569bf.svg";
export { ForwardRef as ReactComponent };